var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.34.933H1.673C1.085.933.608 1.41.608 1.998v14.93a1.065 1.065 0 0 0 1.82.758l4.579-4.582 4.58 4.578a1.066 1.066 0 0 0 1.82-.758V1.998A1.065 1.065 0 0 0 12.339.933Z",
    fillRule: "nonzero",
    stroke: "#738494",
    fill: "none"
  })));
};
export default SvgSave;